import * as Utils from "../libraries/utils";
import * as mutationTypes from "../store/mutation-types";
import { formatPriceZero } from "../domains2/libraries/Utils";

const UpgradeToMenuFromBasket = Object.freeze({
	resetFlag: (self) => {
		self.$store.commit(mutationTypes.SET_UPGRADE_TO_MENU_FROM_BASKET_FLAG, false);
		self.$store.commit(mutationTypes.SET_PRODUCT_SELECTION_TO_REMOVE, []);
	},
	handleStateOnClosing: (self) => {
		if (self.$store.getters.upgradeToMenuFromBasketFlag) {
			Utils.pushGTMInternal(
				"UpgradeBasket",
				self.product.name,
				self.$route.path,
				"",
				{
					email: (self.$store.getters.personData || {}).email,
					selectedRestaurant: (self.globalSelectedShop || {}).shopName
				}
			);
		}
		const ids = self.$store.getters.productSelectionIdToRemove;
		if (ids.length) {
			self.$store.commit(mutationTypes.REMOVE_FROM_CART_BULK, {productSelections: ids.map(psId => ({productSelectionId: psId}))});
		}
	},
	goToCatalog: (self) => {
		const menuCat = self.productCatalog.getCategories().find(x=>x.categoryType === "MENU");
		self.$router.push(
			`/category/${menuCat.extId}?upgradeToMenuProductId=${self.product.id}&productSelectionToRemove=${self.productSelection.productSelectionId}`
		);
	},
	priceDiff: (self) => {
		const menuPrice = self.$store.getters.singleMainProductIdsToMenuIdsMap[self.product.id].price;
		const diff = menuPrice - self.orderLine.price;
		return diff > 0 ? "+"+formatPriceZero(diff) : "";
	},
	upgradeCartState: (self, value) => {
		const singleMainProductIdsToMenuIdsMap = value.reduce((acc, curr) => {
			const mainGroup = curr.product.groups.find(g => g.options.groupType === "main");
			if (mainGroup && mainGroup.products && mainGroup.products[0]) {
				acc[mainGroup.products[0].id] = {};
				const temp = acc[mainGroup.products[0].id];
				temp.id = curr.product.id;
				temp.price = curr.productPrice.discountPrice;
			}
			return acc;
		}, {});
		self.$store.commit(mutationTypes.SET_SINGLE_MAIN_PRODUCT_ID_TO_MENU_PRODUCT_ID_MAP, singleMainProductIdsToMenuIdsMap);
	}
});

export default UpgradeToMenuFromBasket;